/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect, KeyboardEvent } from "react";
import { useTranslation } from "react-i18next";

import {
  SORT_FACILITY_MANAGEMENT_OPTIONS,
  PAGE_NUMBER_OPTIONS,
} from "../../../config";
import { FacilityManagementFilterConditionData } from "../../../models/FacilityFilterConditionData";
import DropdownSelect from "../../FormElement/DropdownSelect";
import { InputBox } from "../../FormElement/InputBox";
import ToggleBtns from "../../ToggleBtns";
import "../../FacilityListComponents/ListTopBar/styles.scss";
import "./styles.scss";

export interface IListTopBarProps {
  conditionFormData: FacilityManagementFilterConditionData;
  filterFormData: any;
  onClickFilter: () => void;
  onClickClearFilterCondition: () => void;
  onChangeFilterFormData: (filterFormData: any) => void;
}

export const ListTopBar: React.FunctionComponent<IListTopBarProps> = (
  props
) => {
  const { t: _t } = useTranslation();
  const t = (key: string) =>
    _t(`facilityManagementPage.facilityManagementList.listTopBar.${key}`);

  const {
    conditionFormData,
    filterFormData,
    onClickFilter,
    onClickClearFilterCondition,
    onChangeFilterFormData,
  } = props;

  const [searchName, setSearchName] = useState<string>(
    filterFormData?.searchName || ""
  );

  useEffect(() => {
    setSearchName(filterFormData?.searchName || "");
  }, [filterFormData?.searchName]);

  // has Condition Filter
  const hasConditionFilter = () => {
    if (
      conditionFormData.organizations.length > 0 ||
      conditionFormData.internalLabels.length > 0 ||
      conditionFormData.isArchived?.shouldInclude !== undefined ||
      (conditionFormData.healthIndex.length > 0 &&
        conditionFormData.healthIndex.some((item) => item.checked))
    ) {
      return true;
    }

    return false;
  };

  // get Labels List
  const getLabelsList = (dataArray: any[]) => {
    const newDataArray: string[] = dataArray.map((item) => {
      return item.name;
    });

    return newDataArray.join(", ");
  };

  const getSortCriteria = (option: string) => {
    const criteria: any = {
      sortBy: option,
    };
    switch (option) {
      case "振り分け状況 ↑":
        criteria.sort = "count.organizations";
        criteria.order = "asc";
        break;
      case "振り分け状況 ↓":
        criteria.sort = "count.organizations";
        criteria.order = "desc";
        break;
      case "施設名 ↑":
        criteria.sort = "name";
        criteria.order = "asc";
        break;
      case "施設名 ↓":
        criteria.sort = "name";
        criteria.order = "desc";
        break;
      case "所在地 ↑":
        criteria.sort = "prefecture+city";
        criteria.order = "asc";
        break;
      case "所在地 ↓":
        criteria.sort = "prefecture+city";
        criteria.order = "desc";
        break;
      case "施設ユーザー狀況 ↑":
        criteria.sort = "has_loc_admins";
        criteria.order = "asc";
        break;
      case "施設ユーザー狀況 ↓":
        criteria.sort = "has_loc_admins";
        criteria.order = "desc";
        break;
      case "健康指数 ↑":
        criteria.sort = "stats.score";
        criteria.order = "asc";
        break;
      case "健康指数 ↓":
        criteria.sort = "stats.score";
        criteria.order = "desc";
        break;
      case "データ最終収集日 ↑":
        criteria.sort = "data_last_collected_at";
        criteria.order = "asc";
        break;
      case "データ最終収集日 ↓":
        criteria.sort = "data_last_collected_at";
        criteria.order = "desc";
        break;
      case "Adminラベル ↑":
        criteria.sort = "internal_labels";
        criteria.order = "asc";
        break;
      case "Adminラベル ↓":
        criteria.sort = "internal_labels";
        criteria.order = "desc";
        break;
      default:
        break;
    }
    return criteria;
  };

  return (
    <div
      className={`list-top-bar flex-grid ${
        hasConditionFilter() ? "filter-after" : ""
      }`}
    >
      <div className="lefts">
        <div className="filter-wrap">
          <div className="filter-some-block">
            <a
              className="btn btn-filter"
              onClick={() => {
                onClickFilter();
              }}
            >
              <i className="icons icon-filter"></i>
              <span className="txt">
                {!hasConditionFilter() ? t("filter") : t("filtered")}
              </span>
            </a>
          </div>
        </div>
      </div>
      <div className="rights flex">
        <div className="search-module">
          <div className="top-txt">&nbsp;</div>
          <InputBox
            value={searchName}
            placeholder={t("search_by_name")}
            isSearch={true}
            classNameContainer={"search-input"}
            onChange={(value: string) => {
              setSearchName(value);
            }}
            onKeyPress={(event: KeyboardEvent<HTMLInputElement>) => {
              if (event.key === "Enter") {
                onChangeFilterFormData({
                  ...filterFormData,
                  searchName: searchName,
                  pageIndex: 1,
                });
              }
            }}
          />
        </div>
        <div className="sort-drop">
          <div className="top-txt">{t("sort")}</div>
          <DropdownSelect
            fieldLabel={""}
            value={filterFormData.sortBy}
            items={SORT_FACILITY_MANAGEMENT_OPTIONS}
            classNameContainer={"sort-dropdown"}
            onChange={(value: string) => {
              onChangeFilterFormData({
                ...filterFormData,
                ...getSortCriteria(value),
                pageIndex: 1,
              });
            }}
          />
        </div>
        <div className="choose-area">
          <div className="top-txt">{t("number_of_facilities_per_page")}</div>
          <ToggleBtns
            selectedValue={filterFormData.numberPerPage}
            options={PAGE_NUMBER_OPTIONS}
            onClickBtn={(option: number) => {
              onChangeFilterFormData({
                ...filterFormData,
                numberPerPage: option,
                pageIndex: 1,
              });
            }}
          />
        </div>
      </div>
      <div className="current-filters">
        <div className="current-filters-top">
          <h3>{t("active_filters")}</h3>
          <button
            className="btn btn-border"
            onClick={(event) => {
              onClickClearFilterCondition();
              event.preventDefault();
            }}
          >
            {t("clear_condition")}
          </button>
        </div>
        <div className="label-area">
          {conditionFormData.isArchived?.shouldInclude !== undefined && (
            <>
              <div className="left-txt" key="archive_status_title">
                {t("archive_status")} :
              </div>
              <div className="labels" key="archive_status_value">
                {conditionFormData.isArchived.shouldInclude
                  ? t("archived")
                  : t("not_archived")}
              </div>
            </>
          )}
          {conditionFormData.healthIndex.length > 0 && (
            <>
              <div className="left-txt" key="health_index_title">
                {t("health_index")} :
              </div>
              <div className="labels" key="health_index_list">
                {conditionFormData.healthIndex
                  .filter((item) => item.checked)
                  .map((item) => item.name)
                  .join(", ")}
              </div>
            </>
          )}
          {conditionFormData.internalLabels.length > 0 && (
            <>
              <div className="left-txt" key="internal_label_title">
                {t("internal_labels")} :
              </div>
              <div className="labels" key="internal_label_list">
                {getLabelsList(conditionFormData.internalLabels)}
              </div>
            </>
          )}
          {conditionFormData.organizations.length > 0 && (
            <>
              <div className="left-txt" key="organizations_title">
                {t("organizations")} :
              </div>
              <div className="labels" key="organizations_list">
                {getLabelsList(conditionFormData.organizations)}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ListTopBar;
